module.exports = __webpack_public_path__ + "assets/8b68e5d9c00841c06a220dfe80d14394.png";